// extracted by mini-css-extract-plugin
export default {"modal":"mP-z","modalOverlay":"nP-z","outfitHeading":"oP-z"};